import {
  TrendingUp,
  Bell,
  Upload,
  Users,
  BarChart3,
  FileText,
  Clock,
  Lock,
} from 'lucide-react';

const features = [
  {
    icon: TrendingUp,
    title: 'Position Monitoring',
    description: 'Track positions across all contracts and accounts in real-time with automatic aggregation.',
  },
  {
    icon: Bell,
    title: 'Smart Alerts',
    description: 'Configurable thresholds at 70%, 90%, and 100% of limits with instant notifications.',
  },
  {
    icon: Upload,
    title: 'Automated Imports',
    description: 'Seamless data ingestion from FCM reports, exchange files, and trading systems.',
  },
  {
    icon: Users,
    title: 'Multi-Client Support',
    description: 'Manage multiple traders and accounts with proper aggregation rules.',
  },
  {
    icon: BarChart3,
    title: 'Compliance Dashboard',
    description: 'Visual overview of position utilization with trend analysis and historical data.',
  },
  {
    icon: FileText,
    title: 'Audit Trail',
    description: 'Complete transaction history and compliance records for regulatory audits.',
  },
  {
    icon: Clock,
    title: 'Real-Time Updates',
    description: 'Live position updates as trades are executed throughout the trading day.',
  },
  {
    icon: Lock,
    title: 'Secure & Reliable',
    description: 'Enterprise-grade security with role-based access control and data encryption.',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="relative py-20 md:py-28 bg-white">
      <div className="container relative">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-slate-900">
            Everything You Need for{' '}
            <span className="text-purple-600">
              Position Limit Compliance
            </span>
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            A comprehensive platform built specifically for commodity trading compliance teams.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-2xl bg-white border border-slate-200 p-6 hover:border-purple-300 hover:shadow-md transition-all"
            >
              <div className="inline-flex rounded-xl bg-slate-100 p-3 mb-4">
                <div className="rounded-lg bg-purple-600 p-2">
                  <feature.icon className="h-5 w-5 text-white" />
                </div>
              </div>
              <h3 className="font-semibold mb-2 text-slate-900">{feature.title}</h3>
              <p className="text-sm text-slate-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
